/** 顶部个人中心组件 */
<template>
  <div class="content">
    <div class="TPersonalNav">
      <div class="navbutton">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <template v-if="status == 1">
                <span style="color: #333;font-size: 14px;margin-right: 20px;">{{ userName }} 您好！ 欢迎使用格瑞德商城</span>
                <el-button type="text" size="mini" @click="routLinkTo('/userCenter')" class="nanbuttontext">
                  个人中心
                </el-button>
              </template>
              <el-button type="text" size="mini" class="nanbuttontext" style="margin-left: 20px;" @click="handleCommand()">
                {{ status == 1 ? "退出登录" : "登录" }}
              </el-button>
            </div>
          </el-col>
          <el-col :span="12" style="display: flex;justify-content: end;">
            <div class="grid-content bg-purple-light">
              <el-dropdown @command="routLinkTo">
                <span class="el-dropdown-link nanbuttontext">
                  我的格瑞德<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="/myOrder">我的订单</el-dropdown-item>
                  <el-dropdown-item command="/myFindSource">我的询价单</el-dropdown-item>
                  <el-dropdown-item command="/favorites">我的收藏</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span style="color: #efefef;padding: 20px;">|</span>
              <el-button type="text" size="mini" class="nanbuttontext" @click="routLinkTo('/myOrder')">我的订单</el-button>
              <span style="color: #efefef;padding: 20px;">|</span>
              <el-button type="text" size="mini" class="nanbuttontext">网站导航</el-button>
              <span style="color: #efefef;padding: 20px;">|</span>
              <el-button type="text" size="mini" class="nanbuttontext">客服</el-button> -->
              <span style="color: #efefef;padding: 20px;">|</span>
              <el-dropdown>
                <span class="el-dropdown-link nanbuttontext">
                  帮助中心<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>交易流程</el-dropdown-item>
                  <el-dropdown-item>符合支付</el-dropdown-item>
                  <el-dropdown-item>查询订单进度</el-dropdown-item>
                  <el-dropdown-item>如何询价</el-dropdown-item>
                  <el-dropdown-item>售后服务</el-dropdown-item>
                  <el-dropdown-item>加入我们</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span style="color: #efefef;padding: 20px;">|</span>
              <span style="color: red">400-618-5015</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/common/Badge";
import { mapGetters } from "vuex";
import { getToken, removeToken, removeNextPage } from "@/axios/cookies.js";
import eventBus from '../../eventbus/eventbus'

export default {
  components: { Badge },
  name: "TopPersonalNav",
  data() {
    return {
      arr: {
        right: [
          {
            des: "我的订单",
            route: "/myOrder",
            notice: 0,
          },
          {
            des: "我的询价单",
            route: "/myFindSource",
            notice: 0,
          },
          {
            des: "我的收藏",
            route: "/favorites",
            notice: 0,
          },
        ],
      },
      status: 1,
      userName:'',
    };
  },
  computed: {
    ...mapGetters([
      "cartNum",
      "userInfo", // 购物车商品数量
    ])
  },
  created() {
    this.isLogin();
    let userEntity = JSON.parse(sessionStorage.getItem('SET_USER_INFO'));
    if(userEntity){
        this.userName = userEntity.nickname
    }
  },
  methods: {
    routLinkTo(val) {
      if (val === '/quickly') {
        this.$router.push(val)
      } else {
        this.$router.push(val)
      }
    },
    handleCommand() {
      this.isLogin();
        if (this.status === 1) {
          removeToken();
          removeNextPage();
          this.$store.commit("reset");
          this.isLogin();
          this.routLinkTo("/indexpage/index");
          sessionStorage.removeItem('SET_USER_INFO')
        } else {
          this.$router.push("/myLogin");
        }
    },
    isLogin() {
      new Promise(rej=>{
        rej(getToken() != undefined ? 1 : 0)
      }).then(res=>{
        this.status = res;
        eventBus.$emit('userInfoEvent', this.status);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.TPersonalNav {
  width: 100%;
  margin: auto;
  height: 40px;
  line-height: 40px;
  color: #333;
  background-color: rgba(0, 0, 0, .1);

  .navbutton {
    max-width: 1440px;
    min-width: 1440px;
    margin: 0 auto;

    .nanbuttontext {
      color: #333;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        color: #F74747;
      }
    }
  }


}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f3f3f3;
  color: #F74747;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopPersonalNav.vue